import { render, staticRenderFns } from "./SupplierDetailsV2.vue?vue&type=template&id=6ca2cac5&"
import script from "./SupplierDetailsV2.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailsV2.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDetailsV2.vue?vue&type=style&index=0&id=6ca2cac5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports